import { render, staticRenderFns } from "./ContestNotification.vue?vue&type=template&id=1dfb1298&scoped=true"
import script from "./ContestNotification.vue?vue&type=script&lang=ts"
export * from "./ContestNotification.vue?vue&type=script&lang=ts"
import style0 from "./ContestNotification.vue?vue&type=style&index=0&id=1dfb1298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb1298",
  null
  
)

export default component.exports